import "./TokensPerSecond.scss";

import { shortNumber } from "../../../../utils/NumbersFormatting";
interface ITokensPerSecondProps {
  tokensPerSecond: number | null;
}

const TokensPerSecond: React.FC<ITokensPerSecondProps> = ({
  tokensPerSecond,
}) => {
  return tokensPerSecond ? (
    <div className="playground-tokens">
      Tokens/s:&nbsp;
      <span>{shortNumber(tokensPerSecond)}</span>
    </div>
  ) : null;
};

export { TokensPerSecond };
